<template>
  <div>
    <v-card class="elevation-12 mb-6">
      <v-card-title class="px-9 pt-7">
        Změna rezervovaného příkonu
      </v-card-title>

      <SearchEAN
        :searchEanLoading="collectionPointLoading"
        @installationLoading="collectionPointLoading = $event"
        routeType="changeOfReservedPower"
      />
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SearchEAN from '@/components/utils/SearchEAN.vue';
import { checkAuth } from '@/components/mixins/checkAuth';

export default {
  name: 'ChangeOfReservedPower',
  components: {
    SearchEAN,
  },
  mixins: [checkAuth],
  data() {
    return {
      loading: false,
      collectionPointLoading: false,
    };
  },
  methods: {
    ...mapActions({
    }),
  },
};
</script>
